<template>
  <ul class="nav nav-mobile-menu">
    <li>
      <md-field>
        <label>Search</label>
        <sinister-select @input="goToSinisterFile($event.roadsId)" />
      </md-field>
    </li>
    <li>
      <drop-down>
        <a slot="title" class="dropdown-toggle" data-toggle="dropdown">
          <transition name="bounce">
            <md-icon class="alert-icon" v-if="showAnimation"
              >notifications_active</md-icon
            >
          </transition>
          <transition name="noti">
            <md-icon class="alert-icon" v-if="!showAnimation"
              >notifications</md-icon
            >
          </transition>
          <span class="notification">{{ alerts.length }}</span>
          <p>pendientes</p>
        </a>

        <ul v-if="alerts.length == 0" class="dropdown-menu dropdown-menu-right">
          <li>
            <div>
              <div class="md-list-item-text no-notification">
                <div class="md-title">No hay notificationes nuevas</div>
              </div>
            </div>
          </li>
        </ul>
        <ul v-if="alerts.length != 0" class="dropdown-menu dropdown-menu-right">
          <li v-for="alert in alerts">
            <div>
              <div @click="showAlert(alert)" class="md-list-item-text">
                <div class="md-title">
                  {{ alert.verb }}
                </div>
                <md-tooltip md-direction="left">{{
                  alert.from_date
                }}</md-tooltip>
              </div>
              <md-button
                @click="removeAlert(alert)"
                class="md-just-icon"
                md-with-hover
              >
                <md-icon class="icon">notifications_off</md-icon>
              </md-button>
            </div>
          </li>
        </ul>
      </drop-down>
    </li>
    <li>
      <a href="#" data-toggle="dropdown" class="dropdown-toggle"
        ><i class="material-icons">person</i>
        <p>Mi cuenta</p></a
      >
    </li>
  </ul>
</template>
<script>

import { mapState } from 'vuex'
import notificationService from '../../../../services/notification'

import { SinisterSelect } from '@/components'

export default {
  components: {
    SinisterSelect,
  },
  data() {
    return {
      search: null,
      selectedEmployee: null,
      showAnimation: true,
      newNoti:true,
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone"
      ]
    };
  },
  methods: {
    newNotification(){
      if(this.newNoti){
        this.showAnimation = true
        setTimeout(this.hideNotifications, 1490);
      }
    },
    hideNotifications(){
      this.showAnimation = false;
    },
    activateAnimation(){
      this.newNoti = true
    },
    goToSinisterFile(id) {
      if (!id) {
        this.$notify({ 
          message: 'No se puede acceder al siniestro porque es inválido.',
          icon: 'close',
          horizontalAlign: 'center',
          verticalAlign: 'bottom',
          type: "danger",
        })
        return
      }
      const routeData = this.$router.resolve({
        name: 'Ficha de Siniestro Carretero',
        params: {
          id
        },
      })

      window.open(routeData.href, '_blank')
    },
    removeAlert(alert){
      this.newNoti = false
      setTimeout(this.activateAnimation, 100);
      notificationService.readNotificaion(alert)
    },
    showAlert(alert){
      let content = 
          ("<h5>"+alert.description+"</h5>")
      if(alert.type == "sinister"){
        content = content + (
          "<h5>Datos del Siniestro:</h5>"+
          '<a style="cursor: pointer;"><ul id="sinister_event">'+
          "<li>#: "+alert.sinister.sinister_number+"</li>"+
          "<li># Requisición: "+alert.sinister.requisition_number+"</li>"+
          "<li>Folio JB: "+alert.sinister.folio_jb+"</li>"+
          "</ul></a>"
        )
        this.$fire({
          title: '<strong>'+alert.verb+'</strong>',
          icon: alert.level,
          html: content,
          showCloseButton: true,
          focusConfirm: false,
          onBeforeOpen: () =>{
            const content = this.$fire.getContent()
            const $ = content.querySelector.bind(content)
            const stop = $('#sinister_event')
            stop.addEventListener('click', () => {
              this.goToSinisterFile(alert.sinister.road_sinister_id)
              this.$fire.close()
            })
          }
        })
        }
      else if(alert.type == "sinisters"){
        content = content + "<h5>Datos de los Siniestros:</h5>"
        alert.sinisters.forEach(sinister => {
          content = content +  (
          '<ul>'+
          '<li>#: '+sinister.sinister_number+'</li>'+
          "<li># Requisición: "+sinister.requisition_number+"</li>"+
          "<li>Folio JB: "+sinister.folio_jb+"</li>"+
          "</ul>"
          )
        });
       this.$fire({
          title: '<strong>'+alert.verb+'</strong>',
          icon: alert.level,
          html: content,
          showCloseButton: true,
          focusConfirm: false,
        }) 
      }
      else if (alert.type == "custom"){
        content = content + (
          alert.content
        )
        this.$fire({
          title: '<strong>'+alert.verb+'</strong>',
          icon: alert.level,
          html: content,
          showCloseButton: true,
          focusConfirm: false,
        }) 
      }
      else{
        this.$fire({
          title: '<strong>'+alert.verb+'</strong>',
          icon: alert.level,
          html: content,
          showCloseButton: true,
          focusConfirm: false,
        })
      }
    },
  },
  computed: {
    ...mapState('alerts', {
      alerts: s => s.alerts
    })
  },
  watch: {
    deep: true,
    'alerts': function () {
      this.newNotification()
    }
  },
};
</script>
<style lang="scss" scoped>
.icon {
  margin-left: 15px !important;
}
.md-title {
  font-size: 14px;
}
.md-just-icon {
  text-align: center;
  vertical-align: middle !important;
  display: inline;
}
.md-list-item-text {
  cursor: pointer;
  color: white;
  text-align: left;
  padding-left: 30px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  overflow: hidden !important;
  width: 190px !important;
  max-width: 190px !important;
  display: inline;
  float: left;
}
.no-notification {
  text-align: center;
  width: 245px !important;
  max-width: 245px !important;
  float: none;
}
.bounce-enter-active {
  animation: bounce-in 1.5s;
}
.bounce-leave-active {
  animation: bounce-out 0.5s;
}
.noti-enter-active {
  animation: noti-in 1.5s;
}
.noti-leave-active {
  animation: noti-out 0.5s;
}

@keyframes noti-in {
  0% {
    transform: scale(1);
    position: relative;
  }
  100% {
    transform: scale(1);
    position: relative;
  }
}
@keyframes noti-out {
  0% {
    transform: scale(0);
    position: absolute;
  }
  100% {
    transform: scale(0);
    position: absolute;
  }
}
@keyframes bounce-in {
  0% {
    transform: scale(1);
    position: relative;
  }
  10% {
    transform: scale(2);
  }
  20% {
    transform: scale(1);
  }
  30% {
    transform: scale(2);
  }
  40% {
    transform: scale(1);
  }
  50% {
    transform: scale(2);
  }
  60% {
    transform: scale(1);
  }
  70% {
    transform: scale(2);
  }
  80% {
    transform: scale(1);
  }
  90% {
    transform: scale(2);
  }
  100% {
    transform: scale(1);
    position: relative;
  }
}
@keyframes bounce-out {
  0% {
    transform: scale(0);
    position: absolute;
  }
  100% {
    transform: scale(0);
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/Extra/MobileMenu.vue